import { getTicketById, getAllTicketByUser,getAllTicket, addTickets, updateTicket, deleteTicket } from '@/api/support.service.js'

export default {
  state:{
    ticket: {},
    tickets: []
  },
  getters:{
    getTickets(state){
      return state.ticket
    },
    getAllTickets(state){
      return state.tickets
    },
    getAllTicketByUser(state){
      return state.tickets
    }
  },
  mutations:{
    setAllTickets(state, tickets){
      state.tickets = tickets
    },
    setAllTicketsByuser(state, tickets){
      state.tickets = tickets
    },
    
   
    setTicket(state, ticket){
      state.ticket = ticket
    },
    addTicket(state, newticket){
      state.ticket = newticket
      state.tickets.splice(0,0, newticket)
    },
 
    updateTicket(state, ticket){
      state.ticket = ticket
    }
  },
  actions:{
 
    async getAllTickets(context){
      let tickets = await getAllTicket()
      let infoTickets = new Array
     
      tickets.forEach(el => {
        getTicketById(el._id).then((data) => {
            infoTickets.splice(0,0,data)
        })
      });
      
    },
    async getAllTicketByUser(context){
      let tickets = await getAllTicketByUser()
      let infoTickets = new Array
     
      tickets.forEach(el => {
        getTicketById(el._id).then((data) => {
            infoTickets.splice(0,0,data)
        })
      });
      
    },

    async setTicket(context, id){
      let ut = await getTicketById(id)
      context.commit('setTicket', ut)
    },
    async addTicketUser(context, ticket) {
   //   let user = await getBotById(ticket.user._id)
   //   ticket.user.first_name = user.first_name
      let newticket = await addTickets(ticket)
      context.commit('addTicket', newticket)
    },
    async updateTicket(context, ticket) {
      let upTicket = await updateTicket(ticket)
      context.commit('updateTicket', upTicket)
    },
  
  }
}


// WEBPACK FOOTER //
// ./src/store/support.store.js